import React from 'react';
import { Link } from 'react-router-dom';


export default function Projects() {
  return (
    <div>
      <div className="pt-5">

        <h1 className="text-4xl font-bold pb-3">
          iOS Projects
        </h1>

        <p className="md:text-xl max-w-3xl mx-auto pb-10 px-10">
          Production iOS applications designed, built, tested, and shipped
          from concept through App Store release.
        </p>

        <div className="space-y-8 lg:grid lg:grid-cols-2 sm:gap-6 xl:gap-10 lg:space-y-0">

          <div className="project p1">
            <Link to="/project1">
              <h3 className="text-2xl">
                True Lock Tuner
              </h3>
            </Link>

            <p className="md:text-xl max-w-lg mx-auto pb-3 px-10">
              Native guitar tuning and practice application featuring
              real-time audio processing, pitch detection, chord recognition,
              StoreKit monetization, analytics, and App Store deployment.
            </p>

            <p className="project-tech">
              Swift • SwiftUI • AVFoundation • StoreKit 2
            </p>
          </div>

          <div className="project p2">
            <Link to="/project2">
              <h3 className="text-2xl">
                SnoozeLock
              </h3>
            </Link>

            <p className="md:text-xl max-w-lg mx-auto pb-3 px-10">
              Mission-based alarm application using AlarmKit, motion sensing,
              barcode scanning, challenge-driven workflows, and native
              device capabilities.
            </p>

            <p className="project-tech">
              Swift • SwiftUI • AlarmKit • CoreMotion • StoreKit 2
            </p>
          </div>

        </div>


        <h2 className="text-3xl font-bold pt-16 pb-8">
          Additional Projects
        </h2>

        <div className="space-y-8 lg:grid lg:grid-cols-2 sm:gap-6 xl:gap-10 lg:space-y-0">

          <div className="project p1">
            <Link to="/project3">
              <h3 className="text-2xl">
                Card Deck
              </h3>
            </Link>

            <p className="md:text-xl max-w-lg mx-auto pb-3 px-10">
              SwiftUI card game demonstrating native interface development,
              application state, game logic, and user interaction.
            </p>

            <p className="project-tech">
              Swift • SwiftUI
            </p>
          </div>

          <div className="project p2">
            <Link to="/project4">
              <h3 className="text-2xl">
                The Cocktail Selector
              </h3>
            </Link>

            <p className="md:text-xl max-w-lg mx-auto pb-3 px-10">
              React application integrating a third-party API to retrieve
              and present dynamic cocktail data.
            </p>

            <p className="project-tech">
              JavaScript • React • REST API
            </p>
          </div>

        </div>

        
      </div>
    </div>
  );
}